<template>
  <v-main class="mt-2">
    <v-container fluid grid-list-lg>
      <v-label>
         Academic Year
      </v-label>
      <v-row class="mt-1">
        <v-col cols="12" md="4" sm="12" lg="4">
          <v-combobox  v-model = "selected_ac" item-text="year" return-object :items="academic" item-value="id"
            label="All Academic Year" outlined single-line dense @change="getClassByAc()">
          </v-combobox>
        </v-col>
      </v-row>
      <div v-if='loading == true' style="text-align:center">
                <v-progress-circular
                :size="50"
                :width="7"
                color="purple"
                indeterminate
                ></v-progress-circular>

            </div>    
      <v-layout row wrap  v-else>
       
        <v-flex v-for="item in items" :key="item.id" lg3 md6 xs12>

          <v-card hover @click="setClassID(item.clid,item.school_type,item.yid)" class="rounded-xl" style="border: 2px solid #8a31e2;">

            <!-- <v-card-title class="green darken-2"> -->
              <!-- <v-card-title    style="background-color:#8a31e2"> -->
            <v-card-title>    
              <h5 style="color: black">Class : {{ item.grade }}</h5>
            </v-card-title>

            <v-card-text>
              <div class="mt-2">
                <h3>
                  Academic Year : {{ item.year }}
                </h3>
              </div>
<!-- 
              <div class="mt-2">
                <h3>
                  Student Name : {{ item.kh_name }}
                </h3>
              </div> -->


            </v-card-text>
            <!-- color="purple lighten-1 " -->
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="setClassID(item.clid,item.school_type,itme)" density="compact" icon="mdi-page-last">  <v-icon>mdi-eye</v-icon></v-btn>

            </v-card-actions>

          </v-card>

        </v-flex>


      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import axios from 'axios'
export default {

  name: 'dasaboard-score',
  data: () => ({
    drawers: true,
    items: [],
    drawer: false,
    group: null,
    academic:[],
    loading:true,
    selected_ac:''

  }),
  methods:
  {

    setClassID(class_id, type_class, academic) {

      window.localStorage.setItem('class_id', class_id)
      window.localStorage.setItem('type_class', type_class)
      window.localStorage.setItem('academic', academic)
      this.$router.push({ name: "view-score" });
    },
    Logout() {


      localStorage.removeItem('hasLogin')
      this.$router.push({ name: "login" });
    },
    getAcademic()
    {
      
       axios.get('http://api.isbbcambodia.org/isbb/public/api/getacademic').then((data)=>{

         this.academic = data.data.data
       

       }).catch((error)=>{
        this.loading = false
         
       })

    },

    getClassByAc(){

      var academic_id = this.selected_ac.id
      this.loading = true
      this.items = JSON.parse(localStorage.getItem("info"))

        axios.get('http://api.isbbcambodia.org/API_ELITE/class_student_by_ac.php?id=' + this.items.student_id+'&academic='+academic_id).then((data) => {

          window.localStorage.setItem('class_info', JSON.stringify(data.data))
          this.loading = false

          this.items = data.data.data
        }).catch((error) => {

        })

    }

    

  },

  created() {
    this.getAcademic()

    this.items = JSON.parse(localStorage.getItem("info"))

    axios.get('http://api.isbbcambodia.org/API_ELITE/class_student.php?id=' + this.items.student_id).then((data) => {

      window.localStorage.setItem('class_info', JSON.stringify(data.data))
      this.items = data.data.data
      this.loading = false

    }).catch((error) => {
      this.loading = false
    })
  }
}
</script>